"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.EOFRuntimeException = void 0;
var EOFRuntimeException = /** @class */ (function (_super) {
    __extends(EOFRuntimeException, _super);
    function EOFRuntimeException(message) {
        if (message === void 0) { message = ''; }
        return _super.call(this, message) || this;
    }
    return EOFRuntimeException;
}(Error));
exports.EOFRuntimeException = EOFRuntimeException;
//# sourceMappingURL=EOFRuntimeException.js.map